import { render, staticRenderFns } from "./helpCenter.vue?vue&type=template&id=3d397f00&scoped=true"
import script from "./helpCenter.vue?vue&type=script&lang=js"
export * from "./helpCenter.vue?vue&type=script&lang=js"
import style0 from "./helpCenter.vue?vue&type=style&index=0&id=3d397f00&prod&lang=scss&scoped=true"
import style1 from "./helpCenter.vue?vue&type=style&index=1&id=3d397f00&prod&scoped=true&lang=scss"
import style2 from "./helpCenter.vue?vue&type=style&index=2&id=3d397f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d397f00",
  null
  
)

export default component.exports